import { render } from "./UserGroup.vue?vue&type=template&id=44dcdc6e"
import script from "./UserGroup.vue?vue&type=script&lang=js"
export * from "./UserGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AirCNavBar/icons/UserGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44dcdc6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44dcdc6e', __exports__)) {
    api.reload('44dcdc6e', __exports__)
  }
  
  module.hot.accept("./UserGroup.vue?vue&type=template&id=44dcdc6e", () => {
    api.rerender('44dcdc6e', render)
  })

}


export default __exports__